import { Icmp, Schema } from "../../../../../@types";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const icmp: Schema<Icmp> = {
  fields: [
    {
      name: "src",
      displayTitle: "Source",
      sortable: true,
      component: (d: Icmp) => (
        <Name
          data={{
            file_name: d.src?.trim(),
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "dst",
      displayTitle: "Destination",
      sortable: true,
      component: (d: Icmp) => (
        <Name
          data={{
            file_name: d.dst?.trim(),
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "type",
      displayTitle: "ICMP Type",
      sortable: true,
      component: (d: Icmp) => <>{d.type}</>
    },
    {
      name: "data",
      displayTitle: "Data",
      sortable: true,
      component: (d: Icmp) => (
        <pre className="dynamic-analysis-tool-pre">{d.data?.trim()}</pre>
      )
    }
  ]
};
